export enum ComponentTypes {
  ContactInfo = 'contactInfo',
  StylistList = 'stylistList',
  Header = 'header',
  Image = 'image',
  Pricing = 'pricing',
  StackedHeader = 'stackedHeader',
  StackedImage = 'stackedImage',
  StackedImages = 'stackedImages',
  TextBlock = 'textBlock',
  TwoColumn = 'twoColumn',
  Video = 'video',
}
